import React, { useEffect, useReducer } from "react";
import { Breadcrumb, Row, Col, Form, Input, Button, notification } from "antd";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
const EditComponentFamily = (props) => {
  const { id } = props.match.params;
  const [form] = Form.useForm();
  const [userInput, setUserInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      id: "",
      component_family: "",
    }
  );

  useEffect(() => {
    axios
      .get(`${getServerUrl()}/master/componentfamily/${id}`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        const details = res.data;
        if (res.data.success === 1) {
          setUserInput({
            id: details.data.cf_id,
            component_family: details.data.component_family,
          });
        } else {
          window.location.href = "/components-family";
        }
      });
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });
  };
  const openNotification = (type) => {
    notification[type]({
      message: "Component Family Updated",
      description: "Component Family successfully",
    });
  };
  const FailNotification = (type) => {
    notification[type]({
      message: "Error",
      description: "Please Fill out Required Fields",
    });
  };
  const onFinish = (values) => {
    console.log(values);
  };
  const onReset = () => {
    form.resetFields();
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (userInput.component_family !== "") {
      axios
        .post(`${getServerUrl()}/master/updatecomponentfamily`, userInput, {
          headers: { "x-auth-token": localStorage.getItem("token") },
        })
        .then((res) => {
          const data = res.data;
          //console.log(data);
          if (data.success === 1) {
            openNotification("success");
          } else {
          }
        });
    } else {
      FailNotification("error");
    }
  };
  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
        <Breadcrumb.Item>Components Settings</Breadcrumb.Item>
        <Breadcrumb.Item>Edit Component Family</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background">
        <h2 className="titles">
          EDIT <span>COMPONENT FAMLILY</span>
        </h2>

        <Row>
          <Col span={16}>
            <h2>Raw Material Type</h2>
            <label>RM TYPE</label>
            <input type="hidden" name="id" value={userInput.id} />
            <Input
              name="component_family"
              value={userInput.component_family}
              onChange={handleChange}
              rules={[
                {
                  required: true,
                  message: "Please enter Component Family Name!",
                },
              ]}
            />

            <br></br>
            <br></br>
            <Button
              type="primary"
              shape="round"
              size="large"
              onClick={handleSubmit}
            >
              Update
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default EditComponentFamily;
